<section>
  <div class="flex flex-row">
    <div>
      <div class="sample-count flex flex-row items-center">
        <mat-icon color="primary">group</mat-icon>
        <span>{{ table1?.c0 }}</span>
      </div>
      <div class="sample-count flex flex-row items-center">
        <mat-icon color="warn">favorite</mat-icon>
        <span>{{ table1?.c1 }}</span>
      </div>
    </div>
    <span class="fill"></span>
    <div class="w-1/2">
      <p>
        <span class="mat-body-2">Linescore N = {{ table1?.c0 }} </span>
        <span [innerHTML]="tabData?.default_sample"></span>
      </p>
    </div>
  </div>
  <ul class="max-w-screen-sm">
     @for (bullet of tabData?.bullets; track $index) {
       <li [innerHTML]="bullet" class="mb-2"></li>
     }
  </ul>
  <ls-table
    [data]="tabData?.tables[0]"
    (change)="$event.selected ? stageTable($event.value) : unstageItem($event.value.id)"
  />
  <ls-table
    [data]="tabData?.tables[1]"
    [id]="tabData?.tables[1].id"
    (change)="$event.selected ? stageTable($event.value) : unstageItem($event.value.id)"
  />
  <ls-table
    *ngIf="tabData?.tables[2]"
    [data]="tabData.tables[2]"
    [id]="tabData.tables[2].id"
    (change)="$event.selected ? stageTable($event.value) : unstageItem($event.value.id)"
  />
</section>
<section>
  <h2 style="margin: 0">Diagnostics</h2>
  <div *ngFor="let diag of tabData?.diagnostics">
    <ls-chart-picker
      (change)="
        $event ? saveLinescale(diag.linescale) : unstageItem(diag.linescale.id)
      "
      [selected]="preSelected[diag.linescale.id]"
      [enabled]="exporting"
      *ngIf="cell$ | async as cell"
    >
      <!-- <linescale
        [lsData]="$any(diag.linescale)"
        *ngIf="!cell.reverse_scales; else revLinescale"
      ></linescale>
      <ng-template #revLinescale>
        <rev-linescale [lsData]="$any(diag.linescale)"></rev-linescale>
      </ng-template> -->
      <linescale-wrapper class="mx-auto" [data]="$any(diag.linescale)" />
    </ls-chart-picker>
    <ls-table
      [data]="diag.table"
      [enabled]="exporting"
      (change)="
        $event.selected
          ? stageTable($event.value)
          : unstageItem($event.value.id)
      "
      [selected]="preSelected[diag.table.id]"
    ></ls-table>
    <mat-divider class="spacer"></mat-divider>
  </div>
</section>
<section>
  <h2 class="mat-headline">Methodology</h2>
  <p class="md-body-1">
    The sample for this {{ tabData?.test_name }} is
    <span [innerHTML]="tabData?.default_sample"></span>.
  </p>
  <p class="md-body-1">
    Respondents select and rate their two competitive alternative brands,
    products or practices in the space, then rate their
    {{ tabData?.concept_var }}. After {{ tabData?.experience_var }}, respondents
    rate again on the same Linescale, which gives a comparison with competition
    and initial expectation. The {{ tabData?.test_item }} is then rated for
    {{ tabData?.diagnostic_var }} and likelihood of Recommendation to friends or
    colleagues. An algorithmic score is calculated and shown to the respondent
    along with the meaning of the score. The respondent is asked if they agree
    with the score or would raise or lower it. (Most agree).
  </p>
  <p
    class="md-body-1"
    *ngIf="tabData?.extra_methodology"
    [innerHTML]="tabData.extra_methodology"
  ></p>
  <p class="md-body-1">
    Respondents describe in their own words why they rated as they did and then
    select up to five main reasons from a list of positive and negative possible
    reasons for rating. Further rating of components of the
    {{ tabData?.test_item }}
    is done {{ tabData?.method_var }}. Additional attitude and behavior
    questions are asked, concluding with demographics.
  </p>
</section>